module.exports = __webpack_public_path__ + "static/media/profile-orange.6234e08b.svg";